import { useSelector } from "react-redux";

const ProjectsRealisedPrestataireDashboard = () => {
    const { list } = useSelector((state) => state.match);

    const containerStyle = {
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "15px"
    };

    const listCard = {
        padding: "15px",
        border: "1px solid #ddd",
        borderRadius: "10px",
        background: "#fff"
    };

    const projetsRealises = list.filter(
        (match) => match.projet && match.projet.statusProjetClient === "realised"
    );

    return (
        <div style={containerStyle}>
            <h2 style={{ textAlign: "center" }}>Mes Projets Réalisés</h2>

            {projetsRealises.length === 0 && (
                <p style={{ textAlign: "center", opacity: 0.7 }}>
                    Aucun projet réalisé pour le moment.
                </p>
            )}

            {projetsRealises.map((match) => (
                <div key={match.id} style={listCard}>
                    <h3>{match.projet.titreProjetClient}</h3>
                    <p style={{ opacity: 0.7 }}>
                        {match.projet.descriptionProjetClient}
                    </p>

                    {match.projet.avis && (
                        <>
                            <p>
                                <strong>Note :</strong>{" "}
                                {"⭐".repeat(match.projet.avis.note)}
                            </p>
                            <p>
                                <strong>Avis client :</strong>{" "}
                                {match.projet.avis.commentaires}
                            </p>
                        </>
                    )}
                </div>
            ))}
        </div>
    );
}
export default ProjectsRealisedPrestataireDashboard;